import getEasing, { easingMap } from './src/getEasing';
import { events } from './src/constants';
export { default as Animation } from './src/Animation';
export { default as interpolate } from './src/interpolate';
export { default as presets } from './src/presets';
export { getEasing, easingMap, events };